/* eslint-disable implicit-arrow-linebreak */
/* global G */
import settings from '@tenant/settings'

const staticItem = {
  route: {
    module: 'static',
    action: 'text',
  },
}

/**
 * Reset App History Effect
 *
 * Empties the navigation stack if the current module and action are defined as a navigation or menu
 * routes.
 *
 * @param {Gaia.Web.Application} app
 * @returns {function(...[*]): *[]}
 */
const resetAppHistory = app => (...args) => {
  const { navigation, menu } = app[G.CONFIGURATION].defaults
  const { staticActions } = settings
  const sessionState = app[G.SESSION][G.STATE]
  // obtaining currently set module and action
  const currentModule = sessionState[G.MODULE]?.[G.CONFIGURATION]?.module
  const currentAction = sessionState[G.ACTION]

  // checking whether current module and action are defined in navigation/menu elements
  const navigationItems = [...navigation, ...menu, ...staticActions || [], staticItem]
  const isNavigation = navigationItems.some(({ route = {} }) =>
    route.module === currentModule && route.action === currentAction)
  // isNavigation && console.log('History reset')
  // clearing history stack if current module and action are defined in navigation/menu
  sessionState[G.PREV] = isNavigation ? [] : sessionState[G.PREV]

  return args
}

export default resetAppHistory
